import { useSelector } from 'react-redux';

const useImpersonationSession = () => {
  const isSuperAdmin = useSelector(state => state.companyAccesses.isSuperAdmin);
  const isImpersonationSession = useSelector(
    state => state.companyAccesses.isImpersonationSession,
  );
  const isPendingImpersonationSession = useSelector(
    state => state.companyAccesses.isPendingImpersonationSession,
  );

  return {
    isSuperAdmin,
    isImpersonationSession,
    isPendingImpersonationSession,
  };
};

export default useImpersonationSession;
